import template from './water-pipes.jade';
import items from '../../../enums/water-pipes';

export default angular
    .module('cian.addForm.commonWaterPipes', ['cian.addForm.fieldTypeDropdown'])
    .directive('cianAfCommonWaterPipes', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.items = items;
        },
        controllerAs: 'waterPipesCount',
        template,
    }))
    .name;
